export default "__VITE_ASSET__N0$VQHnf__"